export const getTotalCost = (items) => {
  let total = null;
  items.map(i => {
    let option = i.options.find(o => o.name === i.status);
    if (option && option?.cost_in_cents !== null) {
      if (total !== null) {
        total += option.cost_in_cents;
      } else {
        total = option.cost_in_cents;
      }
    }
  })
  return total
}

export const getAreasWithCost = (inspection) => {
  let areas = groupItems({ items: inspection?.items ?? [] });

  areas = areas.map(a => {
    let filteredItems = a.items.filter(i => {
      let option = i.options.find(o => o.name === i.status)
      return !!option && option.cost_in_cents !== null;
    });
    let total = getTotalCost(filteredItems);
    return {
      ...a,
      items: filteredItems,
      cost: total
    }
  })

  areas = areas.filter(a => a.cost !== null);
  return areas;
}

const categoryTitle = (item) => item.area_num === 0 ? item.area : `${item.area} ${item.area_num + 1}`

export const groupItems = ({ items }) => {
  let categories = [];

  items.map(item => {
    let index = categories.findIndex(c => c.title === categoryTitle(item));
    if (index >= 0) {
      categories[index].items.push(item)
    } else {
      categories.push({ title: categoryTitle(item), items: [item] })
    }
  });

  return categories
}